module.exports = __webpack_public_path__ + "img/banshee_small.5c0e1eaa.png";